import React from "react";
import { Box } from "@mui/material";

const VideoMessage = ({ message }) => {
  const src = message?.video || message?.url || "";
  if (!src || !String(src).trim()) return null;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-start",
      }}
    >
      <video
        controls
        style={{
          width: "100%",
          maxWidth: 400, // largura máxima do player
          maxHeight: 320, // limita altura para vídeos muito altos
          borderRadius: 8,
        }}
      >
        <source src={src} type="video/mp4" />
        Seu navegador não suporta vídeos.
      </video>
    </Box>
  );
};

export default VideoMessage;
